import { TopTenAccountI } from "@/api/routes/top-ten";

export const TopTenQueryKeys = {
  all: () => ["top-ten"] as const,
};

export interface TopTenDataI {
  /** False while the backend switch is off (every route answers 404). */
  isSwitchedOn: boolean;
  limit: number;
  items: Array<TopTenAccountI>;
}

/** The backend's cap, used until the first answer says otherwise. */
export const TOP_TEN_DEFAULT_LIMIT = 10;

export const isOnTopTen = (
  data: TopTenDataI | undefined,
  campaignId?: string,
  accountId?: string
): boolean =>
  !!data?.items.some(
    (item) => item.campaign_id === campaignId && item.account_id === accountId
  );
